import { Page as Component } from "~/components/specifics/deals/[id]/inspection_reports/Page";

export function Page() {
	return <Component />;
}
